import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import UList from 'components/Lists/UList';

import Columns from '../components/Columns';
import AMTPopup from '../components/popups/AMTPopup';
import SpreadPopup from '../components/popups/SpreadPopup';

const IsoF = () => {
  const [, setLastPage] = useContext(PagesContext);

  const [isAMTPopupOpen, setIsAMTPopupOpen] = useState(false);
  const openAMTPopup = () => setIsAMTPopupOpen(true);

  const [isSpreadPopupOpen, setIsSpreadPopupOpen] = useState(false);
  const openSpreadPopup = () => setIsSpreadPopupOpen(true);

  useEffect(() => setLastPage('isoC'), []);

  const sideContent = 'If you sell your shares within 12 months  of exercising but in a different calendar year then:';

  return (
    <>
      <Columns sideContent={sideContent} theme='red'>
        <UList>
          <li>
            Your{' '}
            <span className='color-red c-pointer' onClick={openAMTPopup}>
              AMT adjustment (alternative minimum tax)
            </span>{' '}
            is included in the year you exercise.
          </li>
          <li>
            You will pay ordinary income tax on the{' '}
            <span className='color-red c-pointer' onClick={openSpreadPopup}>
              spread
            </span>{' '}
            for the year of sale.
          </li>
          <li>
            In addition, you will be subject to the short term capital gains tax rates on the increase after exercise. Keep in mind that
            your basis for AMT should be adjusted based on the prior year’s AMT adjustment.
          </li>
          <li>
            However, if the sale price is below the FMV (fair market value) at exercise, the increase above strike price will be ordinary
            income
          </li>
          <li>Further, if the sale price is below the FMV, the decrease below the strike price will be STCL (short term capital loss)</li>
          <li>You may also be required to pay estimated taxes on a quarterly basis</li>
        </UList>
      </Columns>

      <AMTPopup isPopupOpen={isAMTPopupOpen} setIsPopupOpen={setIsAMTPopupOpen} />
      <SpreadPopup isPopupOpen={isSpreadPopupOpen} setIsPopupOpen={setIsSpreadPopupOpen} />
    </>
  );
};

export default IsoF;
